export const getDate = (date: string, format: 'date' | 'datetime' | 'ISO' = 'datetime'): string => {
  const addZeroPrepend = (value: string | number) => (+value < 10 ? `0${value}` : value);

  if (date) {
    const newDate = new Date(date);

    const day = addZeroPrepend(newDate.getDate());
    const month = addZeroPrepend(newDate.getMonth() + 1);
    const hours = addZeroPrepend(newDate.getHours());
    const mins = addZeroPrepend(newDate.getMinutes());

    switch (format) {
      case 'date':
        return `${day}.${month}.${newDate.getFullYear()}`;
      case 'ISO':
        return `${newDate.getFullYear()}-${month}-${day}`;
      default:
        return `${day}.${month}.${newDate.getFullYear()}, ${hours}:${mins}`;
    }
  }
  return '';
};


export const formatDate = (date?: Date | null) => !date ? null : date.toISOString()

export const dateFromISOtoString = (dateISOString: string) => {
  return getDate( new Date( dateISOString as string).toString()).slice(0, 10)
}
